import React from 'react';
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';
import ConfigurationField from './ConfigurationField';

declare var InovxLoader: any;

export interface ValidationSettingsSectionProps {
    configuration: IAssetClassUpdateDetail;
    tagShapeOptions: Array<{ id: string; name: string }>;
    fontSizeOptions: number[];
    fontStyleOptions: Array<{ name: string; value: string }>;
    onSelectChanged: (event: any) => void;
    onChangeColor: (name: string, color: string) => void;
}

const ValidationSettingsSection: React.FC<ValidationSettingsSectionProps> = ({ configuration, tagShapeOptions, fontSizeOptions, fontStyleOptions, onSelectChanged, onChangeColor }) => {
    return (
        <div className="configuration-form-tab-pane">
            <div className="row d-flex">
                <div className="col-md-12 d-flex w-100" style={{marginTop: '8px'}}>
                    <div className="configuration-grid responsive-grid">
                        <div className="field-col mb-2">
                            <ConfigurationField title={InovxLoader.t('facility:form.tagShape')} inputName="TagShape">
                                <select className="form-control" value={configuration?.TagDisplayData?.TagShape} onChange={onSelectChanged} name="TagShape">
                                    {tagShapeOptions.map((tagShape) => <option key={tagShape.id} value={tagShape.id}>{tagShape.name}</option>)}
                                </select>
                            </ConfigurationField>
                        </div>
                        <div className="field-col mb-2 mt-1">
                            <ConfigurationField title={InovxLoader.t('facility:form.fontSize')} inputName="FontSize">
                                <select className="form-control" value={configuration?.TagDisplayData?.FontSize} onChange={onSelectChanged} name="FontSize">
                                    {fontSizeOptions.map((fontSize) => <option key={fontSize} value={fontSize}>{fontSize}</option>)}
                                </select>
                            </ConfigurationField>
                        </div>
                        <div className="field-col mt-1">
                            <ConfigurationField title={InovxLoader.t('facility:form.fontStyle')} inputName="FontStyle">
                                <select className="form-control" value={configuration?.TagDisplayData?.FontStyle} onChange={onSelectChanged} name="FontStyle">
                                    {fontStyleOptions.map((fontStyle) => <option key={fontStyle.name} value={fontStyle.value}>{fontStyle.name}</option>)}
                                </select>
                            </ConfigurationField>
                        </div>
                    </div>
                    <div style={{ width: '20%', paddingLeft: '20px' }}>
                        <div className="field-col mb-2">
                            <ConfigurationField title={InovxLoader.t('facility:form.tagColor')} inputName="TagColor">
                                <ColorPickerComponent className="ctm-colorpicker" id="tagColor" value={configuration?.TagDisplayData?.TagColor} enableOpacity={false} change={(event: any) => onChangeColor('TagColor', event.value)}></ColorPickerComponent>
                            </ConfigurationField>
                        </div>
                        <div className="field-col mb-2 mt-1">
                            <ConfigurationField title={InovxLoader.t('facility:form.lineColor')} inputName="LineColor">
                                <ColorPickerComponent id="lineColor" value={configuration?.TagDisplayData?.LineColor} enableOpacity={false} change={(event: any) => onChangeColor('LineColor', event.value)}></ColorPickerComponent>
                            </ConfigurationField>
                        </div>
                        <div className="field-col mt-1">
                            <ConfigurationField title={InovxLoader.t('facility:form.fontColor')} inputName="FontColor">
                                <ColorPickerComponent id="fontColor" value={configuration?.TagDisplayData?.FontColor} enableOpacity={false} change={(event: any) => onChangeColor('FontColor', event.value)}></ColorPickerComponent>
                            </ConfigurationField>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ValidationSettingsSection;